import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  return <section className="relative overflow-hidden bg-palomitas-dark" data-id="element-70">
      {/* Colorful accent blobs over dark background */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-71">
        <div className="absolute top-[-15%] right-[-10%] w-[500px] h-[500px] bg-palomitas-coral/15 rounded-full blur-3xl" data-id="element-72"></div>
        <div className="absolute bottom-[-15%] left-[-10%] w-[500px] h-[500px] bg-palomitas-gold/15 rounded-full blur-3xl" data-id="element-73"></div>
        <div className="absolute top-[40%] left-[30%] w-72 h-72 bg-palomitas-pink/10 rounded-full blur-3xl" data-id="element-74"></div>
      </div>

      {/* Text Content */}
      <div className="container px-4 pt-16 pb-10 mx-auto text-center max-w-4xl relative z-10" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-76">
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white px-5 py-2 rounded-full font-bold text-sm uppercase tracking-wide mb-6 border border-white/30" data-id="element-77">
            🍿 El negocio más dulce desde tu casa
          </span>

          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight drop-shadow-lg" data-id="element-78">
            Convirtiendo <span className="text-yellow-200" data-id="element-79">$3.500</span> en{' '}
            <span className="text-yellow-200" data-id="element-80">$35.000</span> por día desde tu
            casa 🍿💰
          </h1>

          <p className="text-xl md:text-2xl text-white/90 mb-10 font-medium max-w-3xl mx-auto drop-shadow" data-id="element-81">
            Aprendé a vender Palomitas Gourmet con un sistema simple, incluso si
            empezás desde cero.
          </p>

          <div className="flex flex-col items-center gap-4 mb-10" data-id="element-82">
            <Button href="#oferta" className="w-full sm:w-auto text-xl px-10 py-5 !bg-palomitas-gold !text-white hover:!bg-palomitas-goldHover shadow-2xl" data-id="element-83">
              👉 Empezar ahora
            </Button>
            <p className="text-white/80 text-sm mt-4 max-w-lg mx-auto" data-id="element-84">
              Quizás hoy no llegás a fin de mes o tu trabajo no te gusta. Querés
              usar tu tiempo en generar ingresos extras y aportar en los gastos
              cotidianos con la familia.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Image displayed fully visible */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.3
    }} className="w-full max-w-5xl mx-auto px-4 pb-16 relative z-10" data-id="element-85">
        <img src="https://cdn.magicpatterns.com/uploads/5BGwFqHujaHQwrAS4M9kKg/ChatGPT_Image_30_abr_2026,_17_45_21.png" alt="Palomitas Gourmet - Libro, tablet y celular" className="w-full h-auto rounded-2xl shadow-2xl border-4 border-white/30" data-id="element-86" />
      </motion.div>
    </section>;
}